import styled from "styled-components";
import DownloadIcon  from '../../assets/icons/button-download-icon.svg';
import DownloadIconHover  from '../../assets/icons/button-download-icon-hover.svg';

const TableComponentDiv = styled.div`
    width: 100%;
    margin-bottom: 46px;
    display: flex;
    flex-basis: 100%;
    flex-direction: column;
    align-items: center;

    .tableTitle {
        font-size: 22px;
        line-height: 31px;
        font-weight: 400;
        color: #FFFFFF;
        font-family: "Eina01-Medium";
        max-width: 855px;
        width: 100%;
        margin: 0 auto 15px;
    }

    .download-button {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 26px;
        width: fit-content;
        height: 48px;
        padding: 0 32px;
        margin: 46px auto 0;
        background-color: transparent;
        border: 1px solid #D4FC00;
        font-size: 14px;
        line-height: 15px;
        font-weight: 400;
        font-family: "Eina01-Medium";
        color: #D4FC00;
        cursor: pointer;
        transition: all ease-in-out 0.3s;

        &::before {
            content: url(${DownloadIcon});
        }

        &:hover {
            background-color: #D4FC00;
            color: #1A0242;

            &::before {
                content: url(${DownloadIconHover});
            }
        }

        @media (max-width: 1023px) {
            max-width: 335px;
            width: 100%;
            padding: 15px 0;
            margin: 30px auto 70px;
        }
    }

    @media only screen and (max-width : 1024px) {
        padding-right: 20px;
        padding-left: 20px;
    }
`;

export {
    TableComponentDiv
}